<template>
  <div class="d-flex flex-column w-100">
    <el-card class="mb-2" shadow="never">
      <h5 style="color: #101010;" v-if="displayTitle">
        {{ displayTitle }}
      </h5>

      <div class="d-flex justify-content-between align-items-center">
        <div
          class="d-flex align-items-center text-truncate"
          style="font-size:14px;color:#606266;height:29px;line-height:29px;"
        >
          <span class="mr-1">No:</span>
          <span>
            {{ baseInfo.proofingNo || $l('detail_placeholder_proofingNo') }}
          </span>
          <el-divider direction="vertical" />
          <el-tag
            size="mini"
            :type="
              baseInfo.proofingStatus === 'Y'
                ? 'success'
                : baseInfo.proofingStatus === 'C'
                ? 'proofing-c'
                : baseInfo.proofingStatus === 'W'
                ? 'warning'
                : baseInfo.proofingStatus === 'D'
                ? 'danger'
                : ''
            "
          >
            {{ baseInfo.v_proofingStatus || 'New' }}
          </el-tag>
          <el-divider direction="vertical" />
          <span class="mr-1">Modify:</span>
          <span>
            {{ baseInfo.modifyByName || '--' }} at
            {{ baseInfo.modifyDate || '--' }}
          </span>
        </div>

        <div class="switch-tabs_wrappers">
          <div class="switch-tabs">
            <div
              v-for="item in switchTabs"
              :key="item.value"
              class="switch-tabs_items"
              :class="{
                active: item.value === activeName,
                disabled: item.disabled,
              }"
              @click="!item.disabled ? (activeName = item.value) : () => {}"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <div class="flex-grow-1">
      <el-card v-show="activeName == 'base'" shadow="never">
        <EditForm
          ref="editForm"
          :disabled="disabled"
          :proofingCode="proofingCode"
          @loaded="(data) => (baseInfo = data)"
        />
        <div class="d-flex justify-content-end mt-3">
          <el-button
            v-if="!disabled"
            type="primary"
            size="small"
            @click="$refs.editForm.save()"
          >
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-card>
      <ProofProduct
        v-if="activeName == 'product'"
        :disabled="disabled"
        :proofingCode="proofingCode"
      />
      <el-card v-if="activeName == 'imgAndDoc'" shadow="never" class="h-100">
        <ProofingImageDoc
          :disabled="disabled"
          :proofingCode="proofingCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import ProofProduct from '../components/proof-product'
import ProofingImageDoc from '../components/proofing-image-doc'
export default {
  name: 'customerManage-proofingRecord-detail',
  components: { EditForm, ProofProduct, ProofingImageDoc },
  data() {
    return { baseInfo: {}, activeName: 'base' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    proofingCode() {
      return this.params.proofingCode
    },
    switchTabs() {
      return [
        {
          label: this.$l('switchTabs_label_base') || '基本信息',
          value: 'base',
        },
        {
          label: this.$l('switchTabs_label_product') || '打样产品',
          value: 'product',
          disabled: !this.proofingCode,
        },
        {
          label: this.$l('switchTabs_label_imgAndDoc') || '图片及文稿',
          value: 'imgAndDoc',
          disabled: !this.proofingCode,
        },
      ]
    },
    displayTitle() {
      const {
        custName,
        custProjectNo,
        categoryName,
        masterCategoryName,
      } = this.baseInfo

      return [
        custName,
        custProjectNo,
        [categoryName, masterCategoryName].filter(Boolean).join('/'),
      ]
        .filter(Boolean)
        .join(' ')
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
  .el-tag.el-tag--proofing-c {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
